import React from 'react'
import { I18n } from '@front/volcanion'
import { IconUtils } from '@front/squirtle/utils'

import { TableCell } from '@mui/material'
import { OrderLink } from '@front/squirtle/elements'

const OrderClientID = ({ row }) => {
  const channelName = row?.channel?.name
  const channelUserType = row?.channel?.user_type
  const channelIcon = IconUtils.getChannelIcon(channelName, channelUserType)

  return (
    <TableCell padding='none' sx={{ width: 100 }}>
      <OrderLink
        record_id={row?.order_id}
        fontSize={14}
        short
        icon={channelIcon}
        _typography={{ noWrap: true, width: '98%' }}
        _tooltipIcon={{ enable: true, title: _.toLower(channelName) }}
        _tooltipText={{ enable: true, title: `${I18n.t('order.label', { count: 1 })} ${row?.order_client_id}` }}
      />
    </TableCell>
  )
}

export default React.memo(OrderClientID)
